const API_BASE_PATH = '/notifications'

const NOTIFICATIONS = {
  LIST: `${API_BASE_PATH}`,
  SUBSCRIPTIONS: `${API_BASE_PATH}/subscriptions`
}

export default NOTIFICATIONS
